import { render, staticRenderFns } from "./VPN.vue?vue&type=template&id=640f5cf8"
import script from "./VPN.vue?vue&type=script&lang=js"
export * from "./VPN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports